import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import FieldWrapper from '../field-wrapper/field-wrapper.vue';
import AbstractField from '@/app/modules/shared/components/forms/inputs/abstract-field/abstract-field';

@Component({
  name: 'bpc-section',
  components: {
    'bpc-field-wrapper': FieldWrapper,
  },
})
export default class Section extends mixins(AbstractField) {
  @Prop({ type: String, default: 'card-title mb-0 pt-4' }) readonly headerClass: string;
  @Prop({ type: Boolean }) readonly subSection: string;
  get showPopoverHelpWithIcon(): boolean {
    // NOTE $te is a VueI18n method to test if a translation exists
    return this.helpMode === 'tooltip' && this.$te(this.help);
  }

  get showFixedHelpBelowField(): boolean {
    // NOTE $te is a VueI18n method to test if a translation exists
    return this.helpMode === 'displayed_below' && this.$te(this.help);
  }

  get showSectionHelp(): boolean {
    return this.showFixedHelpBelowField || this.showPopoverHelpWithIcon;
  }

  get finalHeaderClass(): string {
    return `${this.headerClass} ${this.showSectionHelp ? 'pb-2' : 'pb-3'}`;
  }
}
